import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import {isAllowed} from "@/utils/UniversalFunctions";

Vue.config.productionTip = false

// Sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

// Custom SCSS
import '@/assets/styles/main.scss';

// Initialize auth
store.dispatch('auth/restoreSession').then(r => r);

// Global permission check
Vue.prototype.$isAllowed = isAllowed;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
